<template>
  <div class="container-fluid springter-section">
    <lang-menu></lang-menu>
    <div class="row">
      <div class="col-12">
        <logo type="white" @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 0})"></logo>
      </div>
    </div>
    <div class="section-content">
      <div class="row">
        <div class="col-12">
          <h3>{{ $t('section4Title') }}</h3>
        </div>
      </div>
      <div class="row boxes">
        <div class="col-lg-3 col-md-6 col-sm-12 box box--white">
          <p>{{ $t('section4Box1') }}</p>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 box box--white">
          <p>{{ $t('section4Box2') }}</p>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 box box--white">
          <p>{{ $t('section4Box3') }}</p>
        </div>
        <div class="col-lg-3 col-md-6 col-sm-12 box box--white hidden-sm-down">
          <p>{{ $t('section4Box4') }}</p>
        </div>
      </div>
      <div class="row boxes">
        <div class="col-lg-6 col-md-6 col-sm-6">
          <a @click.prevent="showModal = true" class="button right" role="button" title="Contact">{{ $t('section4ButtonMoreInfo') }}</a>
          <contact-form v-if="showModal" @close="showModal = false"></contact-form>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6">
          <a class="button" title="Springter Brochure" v-bind:href="brochureUrl" role="button">{{ $t('section4ButtonDownload') }}</a>
        </div>
      </div>
    </div>
    <arrow-button color="secondary" @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 4})"></arrow-button>
  </div>
</template>

<script>

import Logo from './shared/Logo';
import ArrowButton from './shared/ArrowButton';
import LangMenu from './shared/LangMenu';
import ContactForm from './shared/ContactForm';

export default {
  name: 'springter-section-4',
  components: {
    Logo,
    ArrowButton,
    LangMenu,
    ContactForm,
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    brochureUrl() {
      return this.$i18n.t('brochureUrl');
    },
  },
};
</script>

<style lang="scss" scoped>
  button.arrow{
    position: absolute;
    left: 50%;
    margin-left: -17px;

    &:hover{
      border-color: $color--brand-secondary;
    }
  }

  button.arrow:hover polyline{
    stroke: $color--brand-secondary;
  }
  .boxes {
    @include mq('phablet', 'max') {
      padding: 10px 20px 0;
    }
    @include mqlandscape(){
      padding: 10px 20px 0;
    }

    .box {
      @include mq('phablet', 'max') {
        border: none;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 15px;
        padding-bottom: 15px;
        margin-bottom: 10px;
      }
      @include mqlandscape(){
        border: none;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 15px;
        padding-bottom: 15px;
        margin-bottom: 10px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/SpringterSection4.vue